import React, {useEffect, useState} from "react";
import {useSingolaRichiestaWF} from "@commons/services/presenze_api/dashboard.queries";
import {Periodo} from "@commons/types";
import {LavoratoreBase} from "@commons/mapping/LavoratoreBase";
import UpdateOrInsertWF from "./wf.employee.updateOrInsert";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {useQueryClient} from "@tanstack/react-query";
import {cloneDeep} from "lodash";
import {FPNetDate} from "@commons/types";

interface ShowWFProps {
    URI: string,

    periodo: Periodo,
    hhPreviste: number,
    hhWeekMedie: number,
    lavoratore: LavoratoreBase,
    elencoGiustificativi?: GiustificativoRecord[],
    richiesteWF?: PresenzeCausaleWFRecord[],
    day: PresenzeGiornataPlusRecord,
    onCancelEdit: () => void,
    onSaveSuccess?: (richiestaWF: PresenzeCausaleWFRecord) => void,
    ope?: 'SHOW_UPDATE' | 'DELETE' | 'UPDATE_OR_INSERT',
    isEditabile: (currentDay: FPNetDate) => boolean, //Se page è MONITOR WF, testo per ogni richiesta se editabile o meno!
}

export const UpdateOrReadWF: React.FC<ShowWFProps> = ({URI, ope, onSaveSuccess, onCancelEdit, ...rest}) => {
    const queryClient = useQueryClient();
    const {data} = useSingolaRichiestaWF(URI);

    // Copia locale della richiesta in edit, viene valorizzata una sola volta appena i dati sono ricevuto dal backend
    const [richiestaWF, setRichiestaWF] = useState<PresenzeCausaleWFRecord | null>(null);
    useEffect(() => {
        if (data && !richiestaWF)
            setRichiestaWF(cloneDeep({...PresenzeCausaleWFRecord.factory(), ...data}));
    }, [richiestaWF, setRichiestaWF, data]);

    // A salvataggio effettuato, allineo risorsa con esito del salvataggio e chiamo onSaveSuccess del container
    const onSaveSuccessLocal = (richiestaWF: PresenzeCausaleWFRecord) => {
        setRichiestaWF(data => ({...data, ...richiestaWF}));
        if (onSaveSuccess)
            onSaveSuccess(richiestaWF);
    }
    const onCancelEditLocal = () => {
        queryClient.invalidateQueries({queryKey: ["singolaRichiestaWF", URI]}); // scarico cache alla chiusura del form

        if (onCancelEdit)
            onCancelEdit();
    }
    return <>{richiestaWF && <UpdateOrInsertWF data={richiestaWF}
                                               onSaveSuccess={onSaveSuccessLocal}
                                               onCancelEdit={onCancelEditLocal}
                                               {...rest}
                                               ope={ope || 'SHOW_UPDATE'}
    />}</>
}
export default UpdateOrReadWF;